import React, { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import Container from '../../../components/Container';
import Header from '../../../components/Header';
import BmcCanvas from '../../../../main/containers/bmc/BmcCanvas';
import Ideation from '../../Ideation';
import TestList from '../../../../main/containers/testing/Containers/TestList';
import BlockSection from './BlockSection';
import PortfolioSectionAdmin from '../../../../main/containers/portfolio/PortfolioSectionAdmin';
import PrevNextLinks from '../../../components/PrevNextLinks';
import ModalBMCList from './ModalBMCList/ModalBMCList';
import { CLASSROOM_LOCAL_STORAGE_SORT_KEY } from '../../../utils/const';
import ExportModal from '../../../../main/containers/portfolio/Export';
import Button from '../../../../main/components/Button';
import { PORTFOLIO_SHORTCUTS } from '../../../../main/utils/helpers/getPortfolioShortCuts';
import Tabs from '../../../components/Tabs';

export default function BmcDashboard({ locales: { admin }, locales }) {
  const {
    portfolio: { page: pageLocales },
  } = locales;
  const { bmcId } = useParams();

  const [visibleModalBmcList, setVisibleModalBmcList] = useState(false);
  const [openModalStatus, setOpenModalStatus] = useState('desc');
  const [exportModalIsOpen, setExportModalIsOpen] = useState(false);

  const breadcrumbs = [
    { title: admin.establishment, to: '' },
    { title: admin.educators, to: '' },
  ];
  const {
    portfolio,
    user,
    bmc,
    bmc: { view },
  } = useSelector((state) => state);
  const { classroomBMCs, classroomBMCsLoading, classroomBMCsMeta } =
    useSelector((state) => state.bmc);

  const {
    bmc: { fetchBmcById, fetchClassroomBMCs, sortClassroomBMCs },
    portfolio: { fetchPortfolioData },
  } = useDispatch();

  useEffect(() => {
    if (bmcId) {
      fetchBmcById(bmcId);
      fetchPortfolioData(bmcId);
    }
  }, [bmcId]);
  const buttons = ({ prev, next }) => {
    return <PrevNextLinks prev={prev} next={next} />;
  };

  const handleFetchClassroomBMCs = (params) => {
    let sort;
    const localStorageSort = localStorage.getItem(
      CLASSROOM_LOCAL_STORAGE_SORT_KEY,
    );
    if (localStorageSort && localStorageSort !== 'null') {
      sort = localStorageSort;
    } else {
      sort = 'name';
    }
    fetchClassroomBMCs({ ...params, bmcId, sort });
  };

  const onModalButtonClick = () => {
    handleFetchClassroomBMCs({ bmcId });
    setVisibleModalBmcList(true);
    setOpenModalStatus('asc');
  };

  const handleSortClassroomBMCs = ({ sort }) => {
    localStorage.setItem(CLASSROOM_LOCAL_STORAGE_SORT_KEY, sort);
    sortClassroomBMCs({ sort, bmcId });
  };

  const handleCloseModalBmcList = () => {
    setVisibleModalBmcList(false);
    setOpenModalStatus('desc');
  };

  const webLink = useMemo(() => {
    return PORTFOLIO_SHORTCUTS.map((i) => i.name).join('-');
  }, [PORTFOLIO_SHORTCUTS]);

  const tabItems = [
    {
      name: admin.ideationTab,
      component: <Ideation locales={locales} />,
    },
    {
      name: admin.canvasTab,
      component: <BmcCanvas locales={locales} listMode="canvas" isPreview />,
    },
    {
      name: admin.testingTab,
      component: <TestList locales={locales} />,
    },
    {
      name: admin.portfolioTab,
      component: <PortfolioSectionAdmin locales={locales} disabled />,
    },
  ];

  return (
    <Container
      locales={locales}
      title={
        user?.current?.name
          ? `${user?.current?.name} ${locales.admin.adminPanel}`
          : ' '
      }
      withChat
    >
      <ModalBMCList
        visible={visibleModalBmcList}
        onClose={handleCloseModalBmcList}
        fetchClassroomBMCs={handleFetchClassroomBMCs}
        loading={classroomBMCsLoading}
        bmcId={bmcId}
        bmcs={classroomBMCs || []}
        sort={handleSortClassroomBMCs}
        meta={classroomBMCsMeta}
        rowClickable
        rowClick={(record) =>
          (window.location.href = `/admin/bmc/${record.id}`)
        }
      />
      <Header
        locales={locales}
        breadcrumbs={breadcrumbs}
        header={bmc?.current?.attributes?.name}
        leftButtons={buttons({
          prev: bmc?.current?.attributes?.previous,
          next: bmc?.current?.attributes?.next,
        })}
        disableBreadcrumbs
        modalButton
        onModalButtonClick={onModalButtonClick}
        openModalStatus={openModalStatus}
      />
      <div className="view-portfolio-section">
        <div className="button-links">
          {portfolio?.slug && (
            <Button
              preview
              variant="outline"
              onClick={() => {
                window.open(
                  `/portfolio/${portfolio?.slug}/${webLink}`,
                  '_blank',
                );
              }}
            >
              {pageLocales.preview}
            </Button>
          )}
          {view === 'portfolio' && (
            <Button share onClick={() => setExportModalIsOpen(true)}>
              {pageLocales.export}
            </Button>
          )}
        </div>
      </div>
      <BlockSection />
      <br />
      <br />
      <Tabs tabs={tabItems} />
      <ExportModal
        locales={locales}
        isOpen={exportModalIsOpen}
        setIsOpen={setExportModalIsOpen}
      />
    </Container>
  );
}
